import { action, Action, thunk, Thunk } from 'easy-peasy'
import { getActiveRegion } from 'Api/authorization'
import { ActiveRegion } from '@mit/atlas-config'

export interface State {
  hasOutage: boolean
}
// eslint-disable-next-line
export interface Actions {
  setHasOutage: Action<this, number>
  clearHasOutage: Action<this>
}
// eslint-disable-next-line
export interface Thunks {
  checkRegionUpdate: Thunk<this, { config?: ActiveRegion, hasHttpError?: boolean }>
}

export interface RegionModel extends State, Actions, Thunks {}

const hasActiveOutageTimeout = (): boolean => {
  return new Date().getTime() < (localStorage.getItem('OutageTimeout') ?? 0)
}

export const regionModel: RegionModel = {
  hasOutage: hasActiveOutageTimeout(),

  // action
  setHasOutage: action((state, timeoutMinutes) => {
    state.hasOutage = true
    // set outage timeout for next x minutes
    localStorage.setItem('OutageTimeout', `${new Date().getTime() + 60000 * timeoutMinutes}`)
  }),
  clearHasOutage: action(state => {
    if (!hasActiveOutageTimeout()) {
      state.hasOutage = false
      // set outage timeout for next x minutes
      localStorage.removeItem('OutageTimeout')
    }
  }),

  // thunk
  checkRegionUpdate: thunk(async (actions, payload) => {
    const regionConfig = payload.config ?? (await getActiveRegion())

    if (regionConfig.failoverState === 'processing') {
      actions.setHasOutage(5)
    } else if (payload.hasHttpError === true) {
      actions.setHasOutage(2)
    } else {
      actions.clearHasOutage()
    }
  })
}
